// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"6a197c41","498":"7385b5e0","621":"4fb47461","703":"2c0d6123","787":"917f2df6"}[chunkId] + ".chunk.js";
};